<template>
  <div
    class="delegation"
    :style="{ width: width, '--mixtmt_mixvw': cssDynamicObj.mixvw }"
  >
    <div class="img-box" :style="{ height: logoHeight }">
      <img v-if="countryImg" :src="countryImg" alt="" />
      <span v-else class="defaultTeamLogo"></span>
    </div>
    <span class="country-name" v-text="countryName"></span>
  </div>
</template>

<script>
// 球员信息
export default {
  props: {
    // 必传参数，国家图片
    countryImg: {
      type: String,
      default: '',
    },
    // 必传参数，国家中文名
    countryName: {
      type: String,
      default: '中国',
    },
    width: {
      type: String,
      default: 'calc(10vw * var(--mixtmt_mixvw))',
    },
    logoHeight: {
      type: String,
      default: 'calc(6.667vw * var(--mixtmt_mixvw))',
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.delegation {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: calc(10vw * var(--mixtmt_mixvw));
  .img-box {
    position: relative;
    width: 100%;
    /* height: 6.667vw; */
    &::before {
      content: '\20';
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      border: 1px solid var(--mixtmt_greyColor5);
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .defaultTeamLogo {
      display: block;
      width: 100%;
      height: 100%;
      background-color: var(--mixtmt_greyColor7);
    }
  }
  .country-name {
    padding-top: calc(1.0416vw * var(--mixtmt_mixvw));
    font-size: calc(1.11vw * var(--mixtmt_mixvw));
    color: var(--mixtmt_greyColor_main);
    line-height: calc(1.666vw * var(--mixtmt_mixvw));
    text-align: center;
  }
}
</style>
